import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="flex items-center space-x-1 p-2 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900"
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <Sun 
        className={`h-5 w-5 transition-colors duration-200 ${
          theme === 'light' 
            ? 'text-yellow-500' 
            : 'text-gray-400 dark:text-gray-600'
        }`} 
      />
      <div className="w-px h-4 bg-gray-300 dark:bg-gray-600" />
      <Moon 
        className={`h-5 w-5 transition-colors duration-200 ${
          theme === 'dark' 
            ? 'text-blue-400' 
            : 'text-gray-400 dark:text-gray-600'
        }`} 
      />
    </button>
  );
};
